import {
    HOW_MUCH_YOU_NEED_TO_SAVE_CALCULATOR_SHOW_RESULT_SUMMARY
} from "../../../actions/savingsCalculator/howMuchYouNeedToSaveCalculator.js";
import { fireGtmEvent } from "../gtmEvents.js";
import { submitEarnEvent, earnEventMap } from '../rewards';
import { findOtherEventIndex, otherEventTracking } from '../otherEventTracking';

export const howMuchYouNeedToSaveCalculatorFieldTracking = (store, next, action) => {
    const result = next(action);
    let otherEventIndex;

    const field = (() => {
        switch (action.type) {
            case HOW_MUCH_YOU_NEED_TO_SAVE_CALCULATOR_SHOW_RESULT_SUMMARY:
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                submitEarnEvent(earnEventMap.savings)
                    .catch(error => console.warn("submitEarnEvent failed:", error?.response?.data || error.message));

                fireGtmEvent('calculator_complete', { calculator_type: 'Savings Calculator' });
                return 'How much do you need to save';
        }
    })();

    if (field) {
        otherEventTracking(action.type, otherEventIndex, field);
    }

    return result;
};
